import Vue from 'vue';
// import { Button, Swipe, SwipeItem, Popup ,Radio,Icon,List,PullRefresh,Toast} from 'vant';
import {  Swipe, SwipeItem, Popup ,Toast} from 'vant';
// Vue.use(Button);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
// Vue.use(Indicator);
// Vue.use(Radio);
// Vue.use(Icon);
// Vue.use(List);
// Vue.use(PullRefresh);
Vue.use(Toast)
Toast.setDefaultOptions({ duration: 5000 }); 